import { useState } from 'react'
import { useAuthStore } from '@/stores/auth'

export function EmailVerificationBanner() {
  const { user } = useAuthStore()
  const [dismissed, setDismissed] = useState(false)

  // Supabase sets email_confirmed_at when verified
  const isVerified = user?.email_confirmed_at

  if (isVerified || dismissed) return null

  return (
    <div className="bg-amber-50 dark:bg-amber-900/20 border-b border-amber-200 dark:border-amber-800 px-4 py-2.5 flex items-center justify-between gap-4">
      <div className="flex items-center gap-2 text-sm text-amber-800 dark:text-amber-200">
        <span className="material-symbols-outlined text-[18px]">mail</span>
        <span>Please verify your email address. Check your inbox for a confirmation link.</span>
      </div>
      <button
        onClick={() => setDismissed(true)}
        className="text-amber-600 dark:text-amber-400 hover:text-amber-800 dark:hover:text-amber-200 shrink-0"
      >
        <span className="material-symbols-outlined text-[18px]">close</span>
      </button>
    </div>
  )
}
